// Vendor
import $ from 'jquery';
import SM from 'scrollmagic';

let controller;

class StickyNav {
	constructor($el, opts) {
		this.$parent = $el.parent();
		this.$el = $el;
		this.$sections = opts.$sections;
		this.$targetY = opts.$targetY;

		this.isExpanded = false;
		this.heights = [];
		this.scene = [];

		// Classes
		this.clsSticky = 'fixed';
		this.clsExpanded = 'expanded';
		this.clsBottom = 'bottom';

		controller = new SM.Controller({
			globalSceneOptions : {
				triggerHook : .65
			}
		});

		// Events
		this.attachEvents();
	}

	attachEvents() {
		this.fixedWidth();
		this.setHeights();

		$(window).on('scroll', () => {
			this.navSticky();
		});

		// Fixed element needs a width
		$(window).on('resize', () => {
			this.fixedWidth();
			this.setHeights();
		});

		if ( this.$sections ) {
			this.$sections.each((i, v) => {
				this.setToggleNav(i, v);
			});
		}
	}

	setToggleNav(current, element) {

		let offset = 300;

		// When prev is short and current is long
		if (this.heights[current-1] < 350 && this.heights[current] > 300) {
			offset = 550 - this.heights[current-1];
		} else if (this.heights[current] < 400) {
			offset = 550 - this.heights[current];
		}

		this.scene[current] = new SM.Scene({
			triggerElement : element,
			duration : this.heights[current],
			offset: offset,
		}).setClassToggle('.vaccine-disease-nav-list li:nth-child(' + (current + 1) + ')', 'is-active').addTo(controller);
	}

	setHeights() {
		if ( this.$sections ) {
			this.$sections.each((i, v) => {
				this.heights[i] = $(v).outerHeight();
			});
		}
	}

	fixedWidth() {
		this.$el.css('width', '');
		if (window.innerWidth > 767) {
			this.$el.css('width', this.$parent.width());
		}
	}

	navSticky() {
		if (window.innerWidth < 768) {
			return false;
		}

		// Current Scroll Position
		let currentY = $(window).scrollTop();

		// Height of header
		let HEADER_HEIGHT = (window.innerWidth > 1024) ? 80 : 114;
		if (this.isExpanded && window.innerWidth > 1024) {
			HEADER_HEIGHT = 138;
		}

		// Positions where fixed should be applied
		let minY = this.$targetY.offset().top - HEADER_HEIGHT;
		let maxY = minY + this.$targetY.outerHeight() - this.$el.outerHeight();

		if (currentY > minY) {
			this.$el.addClass(this.clsSticky);
		} else {
			this.$el.removeClass(this.clsSticky);
		}

		if (this.previousScrollTop && this.previousScrollTop > currentY) {
			//scrolled up
			this.$el.addClass(this.clsExpanded);
			this.isExpanded = true;

			// Remove 'Bottom' class
			if (this.$el.hasClass(this.clsBottom) && currentY < (this.$el.offset().top - HEADER_HEIGHT )) {
				this.$el.removeClass(this.clsBottom);
			}

		} else {
			//scrolled down
			this.$el.removeClass(this.clsExpanded);
			this.isExpanded = false;

			// Add 'Bottom' class
			if (currentY > maxY) {
				this.$el.addClass(this.clsBottom);
			}
		}

		this.previousScrollTop = currentY;
	}
}

export default StickyNav;
